export const LoginInProgress = (in_progress) => {
    return {
        type: 'LOGIN_IN_PROGRESS',
        payload: in_progress
    }
};



// WEBPACK FOOTER //
// ./src/scenes/Login/components/CoreContent/components/Submit/actions.js